import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/readers-and-intercoms/g3-intercom.png";
import type { Product } from "../../types";
import { readersAndIntercom } from "../product-list-groups/readersAndIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  twoWayIntercom,
} from "../properties";

export const g3Intercom: Product = {
  id: "g3Intercom",
  productTitle: "G3 Intercom",
  description: "g3Intercom.description",
  descriptionMaxWidth: 200,
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/door-access/ua-g3-intercom`],
  productListGroup: readersAndIntercom,
  storePathParts: {
    category: "door-access-intercoms",
    productSlug: "ua-g3-intercom",
  },
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '324.8 x 113.7 x 28.3 mm\n(12.8 x 4.5 x 1.1")',
      },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "touchPassSupport",
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
    {
      propertyId: "appleTouchPassAccess",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "builtInFloodlight",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "intercoms.common.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
};
